export default {
    data() {
        return {
        };
    },

    methods: {
        checkIfLicencedByKey(key) {
            if (!key) {
                return true;
            } else {
                //console.log(key, this.LicenceString.includes(key));
                return this.LicenceString.includes(key);
            }
        },

        checkIfFeatureEnabledByKey(key) {
            if (!key) {
                return true;
            } else {
                return this.Features[key];
            }
        },
    },

    computed: {
        Features() {
            return this.$store.state.GlobalSettings.Features;
        },
        LicenceString() {
            return this.$store.state.GlobalSettings.Licences;
        },
        Licences() {
            return this.$store.getters['Licences'];
        },
        AutoDispatchLicence() {
            return this.Licences.AutoDispatchLicence === true ? true : false;
        },
        ContractsLicence() {
            return this.Licences.ContractsLicence === true ? true : false;
        },
        MapsLicence() {
            return this.Licences.MapsLicence === true ? true : false;
        },
        MultipleFirmsLicence() {
            return this.Licences.MultipleFirmsLicence === true ? true : false;
        },
        ProPlusLicence() {
            return this.Licences.ProPlusLicence === true ? true : false;
        },
        QuotationLicence() {
            return this.Licences.QuotationLicence === true ? true : false;
        },
        TimeReportCalendaLicence() {
            return this.Licences.TimeReportCalendaLicence === true ? true : false;
        },
        CheckListLicence() {
            return this.Licences.CheckListLicence === true ? true : false;
        },
        CalendarMode() {
            return this.Licences.CalendarMode;
        },
        CustomerPortalLicence() {
            return this.Licences.CustomerPortalLicence === true ? true : false;
        },
        PartnerPortalLicence() {
            return this.Licences.PartnerPortalLicence === true ? true : false;
        },
    },
}